import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from 'components/Footer';
import Header from 'components/Header';
import HomePage from 'pages/HomePage'; // Главная страница
// import AboutPage from 'pages/AboutPage'; // Страница "О нас"
import NotFoundPage from 'pages/NotFoundPage'; // Страница 404
import 'styles/header.css';
// import 'styles/main.css';
// import 'styles/footer.css';
import 'styles/globals.css';
const Layout = () => {
    return (
        <div className="layout">
            <Router>
                <Header/>
                <RoutesConfig/>
                <Footer/>
            </Router>
        </div>
    );
}

// Пример файла src/routes.js

const RoutesConfig: React.FC = () => {
    return (
        <Routes>
            {/* Главная страница */}
            <Route path="/" element={<HomePage />} />
            {/* Страница "О нас" */}
            {/* <Route path="/about" element={<AboutPage />} /> */}
            {/* Маршрут для всех остальных путей (404) */}
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default Layout;